document.addEventListener("teeinblue-event-component-injected", function () {
  const checkElementRendered = setInterval(() => {
    const elementToMove = document.querySelector(".delivery-widget__theme");
    const insertAfterElement = document.querySelector(".tee-product-price");
    if (elementToMove && insertAfterElement) {
      clearInterval(checkElementRendered);
      insertAfterElement.after(elementToMove.cloneNode(true));
    }

    const elementToMove1 = document.querySelector(
      ".product-form__image.text--left"
    );
    const insertAfterElement1 = document.querySelector(
      "#tee-artwork-form .msg__container"
    );
    console.log(insertAfterElement1);
    if (elementToMove1 && insertAfterElement1) {
      insertAfterElement1.after(elementToMove1);
    }
  }, 500);
});

document.addEventListener("teeinblue-event-component-injected", function () {});
